var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "../../templates/flex";
import getBackground from "./background";
import getPillColor from "../colors";
var getPillWidth = function (width, tiny) {
    if (width)
        return width;
    return tiny && "8px";
};
var getPillHeight = function (height, tiny) {
    if (height)
        return height;
    return tiny ? "8px" : "20px";
};
var Container = styled(Flex).attrs(function (_a) {
    var _b = _a.round, round = _b === void 0 ? 999 : _b, hollow = _a.hollow, flavour = _a.flavour, borderColor = _a.borderColor, tiny = _a.tiny, width = _a.width, height = _a.height;
    return ({
        padding: !tiny && [1, 2],
        round: round,
        border: {
            side: "all",
            color: borderColor ? borderColor : getPillColor(hollow ? "border" : "background", flavour),
            size: "1px",
        },
        height: getPillHeight(height, tiny),
        width: getPillWidth(width, tiny),
        justifyContent: "center",
        alignItems: "center",
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  cursor: pointer;\n"], ["\n  ", ";\n  cursor: pointer;\n"])), getBackground);
export default Container;
var templateObject_1;
